<ng-container *ngIf="form" [formGroup]="form">
  <div class="mb-20">
    <div class="mb-10">
      <p500-ui-checkbox-field
        i18n-label="@@settings.enable_buttons_color"
        label="Enable Buttons Color"
        formControlName="buttonsColorEnabled"
      ></p500-ui-checkbox-field>
    </div>
    <p500-ui-color-select-field
      *ngIf="isButtonsColorEnabled"
      i18n-label="@@settings.buttons_color"
      label="Buttons Color"
      formControlName="buttonsColor"
    ></p500-ui-color-select-field>
  </div>
  <div class="mb-20">
    <div class="mb-10">
      <p500-ui-checkbox-field
        i18n-label="@@settings.enable_text_color"
        label="Enable Text Color"
        formControlName="textColorEnabled"
      ></p500-ui-checkbox-field>
    </div>
    <p500-ui-color-select-field
      *ngIf="isTextColorEnabled"
      i18n-label="@@settings.text_color"
      label="Text Color"
      formControlName="textColor"
    ></p500-ui-color-select-field>
  </div>
  <div>
    <p500-ui-checkbox-field
      i18n-label="@@settings.enable_copyright_replacement"
      label="Enable Copyright Replacement"
      formControlName="replaceCopyrightEnabled"
    ></p500-ui-checkbox-field>
  </div>
</ng-container>
